module.exports = __webpack_public_path__ + "img/poi.faf87dbd.png";